<template>
  <div v-show="loaded" class="h-full">
      <div v-show="dataAvailable" class="mt-12">
        <canvas ref="pieChart"></canvas>
      </div>
      <div v-show="!dataAvailable" >
        <p class="mt-24 text-center">{{ $t('widget.noData') }}</p>
      </div>
  </div>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import Chart from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ApiService from "@/services/ApiService";
import {useApiStore} from "@/stores/ApiStore";

const apiDataStore = useApiStore();
let emit =  defineEmits(["loaded"]);
let apiService = new ApiService;

let props = defineProps({
  source: String,
  update: Number,
  colorPalette: Object,
  deliveryType: Boolean
})

let pieChart = ref(null);
let chart = ref();
let data = ref();
let subject = ref();
let dataAvailable = ref()
let loaded =ref(false)

onMounted(  async () => {
      await refreshData();
    }
)

async function refreshData(){
  let values = [];
  let amounts = [];
  data.value = await apiService.get(props.source)
  emit("loaded", true)
  subject.value = data.value.subject
  if (data.value.data.length <1){
    dataAvailable.value = false
  }else{
    dataAvailable.value = true
    data.value.data.forEach(entry => {
      values.push(languageNames.of(entry.value))
      amounts.push(entry.amount)
    })
    let colors = props.colorPalette.pieChart
    let reversedColors = colors.slice().reverse()
    if(values.length < 2)
    {
      colors = props.colorPalette.primary
      reversedColors = props.colorPalette.secondary
    }
    chart.value = new Chart(pieChart.value, fillData(values, amounts, colors, reversedColors, subject.value))
  }
  loaded.value =true
}
function fillData(values, amounts, colors, reversedColors, subject) {
  let newValues = values;
  if (props.deliveryType){
    newValues = translateValues(apiDataStore.getLang, values)
  }
  return {
    type: "pie",
    data: {
      labels: newValues,
      datasets: [
        {
          data: amounts,
          backgroundColor: colors,
          datalabels: {
            anchor: 'center',
            align:'end'
          }
        }
      ]
    },
    plugins: [ChartDataLabels],
    options: {
      maintainAspectRatio: false,
      responsive: true,
      plugins:{
        tooltip:{
          callbacks:{
            title: function(tooltipItem){
              return tooltipItem[0].label
            },
            label: function (tooltipItem){
              return  tooltipItem.formattedValue + ' ' + subject ;
            }
          }
        },
        datalabels: {
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          formatter: (value, ctx) => {
            let sum = 0;
            let dataArr = ctx.chart.data.datasets[0].data;
            dataArr.map(data => {
              sum += data;
            });
            return (value * 100 / sum).toFixed(0) + "%";
          },
          borderColor: 'white',
          borderRadius: 25,
          borderWidth: 1,
          color: reversedColors,
          display: function( context) {
            let sum = 0
            let dataArr = context.dataset.data;
            dataArr.map(data => {
              sum += data;
            });
            return (context.dataset.data[context.dataIndex] * 100 / sum).toFixed(0) > 7;
          },
          font: {
            weight: 'bold'
          },
          padding: 3,
        },
        legend:{
          position:'right',
        }
      }
      }


  }
}

watch(() => props.update, async () => {
  chart.value.destroy()
  emit("loaded", false)
  await refreshData(props.source);
})

const languageNames = new Intl.DisplayNames(
    [apiDataStore.getLang], { type: 'language'}
);

// damn i18n doesnt want to work in js...
function translateValues(lang, values) {
  let res = []
  switch (lang) {
    case 'nl':
      values.forEach(entry => {
        if (entry === 'deliver'){
          res.push('Levering')
        }else if(entry === 'pickup'){
          res.push('Afhalingen')
        }
      })
      break
    case 'de':
      values.forEach(entry => {
        if (entry === 'deliver'){
          res.push('Lieferung')
        }else if(entry === 'pickup'){
          res.push('Abholung')
        }
      })
      break
    case 'en':
      values.forEach(entry => {
        if (entry === 'deliver'){
          res.push('Levering')
        }else if(entry === 'pickup'){
          res.push('Ophaling')
        }
      })
      break
    case 'fr':
      values.forEach(entry => {
        if (entry === 'deliver'){
          res.push('Livraison')
        }else if(entry === 'pickup'){
          res.push('Ramassage')
        }
      })
      break
    default:
      return 'Invalid language code';
  }
  return res
}
</script>
